// extracted by mini-css-extract-plugin
module.exports = {"title":"WechatPayModal_title__1paCD","scanTip":"WechatPayModal_scanTip__375mT","payResult":"WechatPayModal_payResult__MlGS7"};